import type { CheckResult } from "../types";

function statusText(status: string) {
  if (status === "pass") return "通过";
  if (status === "partial") return "部分满足";
  return "未满足";
}

export default function ResultView({ result }: { result: CheckResult }) {
  return (
    <div className="card">
      <div className="actions" style={{ justifyContent: "space-between" }}>
        <div>
          <div className="tag">需求类型：{result.requirementType}</div>
        </div>
        <div className="status-text">
          评分：{Math.round(result.score)} / 100
          {result.modelVersion ? <span className="muted">（{result.modelVersion}）</span> : null}
        </div>
      </div>
      <p style={{ marginTop: 8 }}>{result.summary}</p>
      <div className="result-grid">
        {result.items.map((item) => (
          <div key={item.specId} className="card">
            <div className={`chip ${item.status}`}>{statusText(item.status)}</div>
            <h4 style={{ margin: "8px 0" }}>
              {item.title} <span className="muted">权重 {item.weight}</span>
            </h4>
            <div className="small"><strong>原因：</strong>{item.reason}</div>
            <div className="small" style={{ marginTop: 6 }}>
              <strong>建议：</strong>
              {item.suggestion}
            </div>
          </div>
        ))}
      </div>
      {result.gaps && result.gaps.length > 0 && (
        <div style={{ marginTop: 12 }}>
          <h4 style={{ margin: "6px 0" }}>缺失项概览</h4>
          <ul>
            {result.gaps.map((gap) => (
              <li key={gap} className="small">{gap}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
